import React from "react";
import Select from "react-select";

const FormMultiSelect = ({
  options,
  value,
  onChange,
  placeholder = "Select...",
  isMulti = true,
  isDisabled = false,
  className,
  closeMenuOnSelect = false,
}) => {
  return (
    <Select
      className={className}
      isMulti={isMulti}
      isDisabled={isDisabled}
      options={options}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      closeMenuOnSelect={closeMenuOnSelect}
      styles={{
        control: (provided) => ({
          ...provided,
          borderRadius: "5px",
          borderColor: "#d1d5db",
          boxShadow: "none",
          "&:hover": {
            borderColor: "#9ca3af",
          },
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
        }),
      }}
    />
  );
};

export default React.memo(FormMultiSelect);
